import React from "react";
import PropTypes from "prop-types";
import "../../../css/DesignSystem/Tabs/Tabs.css";

const Tabs = ({ tabs, activeTab, onTabChange, noShadow }) => {
  return (
    <div className={`tabs ${noShadow ? "no-box-shadow" : ""}`}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          className={`tab ${activeTab === tab.id ? "active" : ""}`}
          onClick={() => onTabChange(tab.id)}
        >
          <span className="Button-Text-Medium">{tab.label}</span>
          {tab.count !== undefined && (
            <span className="tab-count Content-Small">{tab.count}</span>
          )}
        </button>
      ))}
    </div>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      count: PropTypes.number,
    })
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
};

export default Tabs;
